import { removeUserToken } from '@/utils/localStorage'
import router from '../router'

export default {
  install (Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$auth = {
      logout: () => {
        removeUserToken()
        Vue.prototype.$liff.logout()

        const currentPath = router.history.current.path ?? '/'
        if (currentPath !== '/') {
          router.push('/')
        }
      }
    }
  }
}
